<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <div class="row">
          <div class="col">
            <div class="card-header row">
              <div class="col">
                <h4 class="card-title float-left">Promotions - {{this.$route.params.action}}</h4>
              </div>
              <div class="col">
                <a class="btn btn-primary float-right text-white" @click="$router.go(-1)">Back</a>
              </div>
            </div>
            <div class="card-body">
              <CRUD endpoint="products/promotion" singular="Promotion" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import CRUD from "@kaweb-ltd/admin-vue/CRUD.vue";
  export default {
    components: {
      CRUD
    },
    data () {
      return {
      }
    }
  }
</script>
<style>

</style>
